import React, { useContext, useEffect, useState } from "react";

import { SalesContext } from "../../context/salesContext";
import WorkOrder from "../details/WorkOrder";
import { DetailModal, Spinner } from "../ui";

const WorkOrderModal = ({ open, id, onClose }) => {
    const { action } = useContext(SalesContext);
    const [workOrder, setWorkOrder] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!open || !id) return;
        let cancelled = false;
        setLoading(true);
        setWorkOrder(null);
        (async () => {
            const sale = await action.getSale(id);
            if (cancelled) return;
            setWorkOrder(sale || null);
            setLoading(false);
        })();
        return () => {
            cancelled = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open, id]);

    return (
        <DetailModal
            open={open}
            onClose={onClose}
            size="xl"
            title="Work Order Details"
            fullPagePath={id ? `/work-orders/${id}` : undefined}
        >
            {loading || !workOrder ? (
                <div className="flex h-48 items-center justify-center">
                    <Spinner size="lg" />
                </div>
            ) : (
                <WorkOrder workOrder={workOrder} setWorkOrder={setWorkOrder} />
            )}
        </DetailModal>
    );
};

export default WorkOrderModal;
